import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { addInstitute, getCountriesAndCities } from '../../api/institute';
import { InstituteForm } from '../../components';

const AddInstitue = () => {
    const initialValues = {
        admin: '',
        name: '',
        institute_type: '',
        phone: '',
        institute_email: '',
        address: {
            fisrt_line: '',
            second_line: '',
            country: '',
            city: '',
            pincode: '',
        }
    }
    const [values, setValues] = useState(initialValues)
    const [loading, setLoading] = useState(true)
    const [loadingCities, setLoadingCities] = useState(true)
    const [countries, setCountries] = useState([])
    const [cities, setCities] = useState([])
    const { user } = useSelector((state) => ({ ...state }));
    const history = useHistory()

    useEffect(() => {
        getCountriesAndCities()
            .then(res => {
                setCountries(res.data.data)
                setLoading(false)
            })
            .catch(err => {
                console.log(err)
            })
    }, [])

    const handleChange = e => {
        setValues({ ...values, [e.target.name]: e.target.value })
    }

    const handleAddressChange = e => {
        let { address } = values;
        setValues({ ...values, address: { ...address, [e.target.name]: e.target.value } })
    }

    const handleCityChange = city => {
        let { address } = values;
        address.city = city
        setValues({ ...values, address })
    }

    const handleCountryChange = country => {
        let { address } = values;
        address.country = country
        setValues({ ...values, address })
    }

    const handleSumbit = e => {
        e.preventDefault()
        values.admin = user._id
        setLoading(true)
        addInstitute(user._id, user.token, values)
            .then(res => {
                setValues(initialValues)
                toast.success('Institute add successfully, now please verify your email to continue')
                history.push('/')
            })
            .catch(err => {
                setLoading(false)
                console.log(err)
                toast.error(err.response ? err.response.data : "some error please try again later")
            })
    }

    return (
        <div className='container'>
            <InstituteForm
                values={values}
                handleChange={handleChange}
                handleAddressChange={handleAddressChange}
                handleSumbit={handleSumbit}
                handleCityChange={handleCityChange}
                handleCountryChange={handleCountryChange}
                loading={loading}
                setLoading={setLoading}
                loadingCities={loadingCities}
                setLoadingCities={setLoadingCities}
                countries={countries}
                cities={cities}
                setCities={setCities}
            />
        </div>
    );
};

export default AddInstitue;